import { render, staticRenderFns } from "./ButtonSimple.vue?vue&type=template&id=5e226bd0&scoped=true&"
import script from "./ButtonSimple.vue?vue&type=script&lang=js&"
export * from "./ButtonSimple.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSimple.vue?vue&type=style&index=0&id=5e226bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e226bd0",
  null
  
)

export default component.exports